/* fiber-lista-black v1.0 (2026-10-02) — captação da Lista Black Fiber (Black Friday).
   Usado pela página /pages/black-friday e pelo pop-up do site. Config em window.FIBER_LISTA_BLACK
   (snippet fiber-lista-black.liquid). Envia o lead pro serviço fiber_lista-black (grava no ActiveCampaign)
   e dispara o evento Lead no Pixel do Meta e generate_lead no Google (GA4 + Ads se houver send_to). */
(function () {
  "use strict";
  if (window.FiberListaBlack) return;
  var CFG = window.FIBER_LISTA_BLACK || {};
  var UTM_KEY = "fbl_utm", JOINED = "fbl_joined";

  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  // guarda as UTMs da primeira entrada (30 dias) pra gravar junto com o lead
  (function captureUtm() {
    var q = new URLSearchParams(location.search), src = q.get("utm_source");
    if (!src) return;
    store(UTM_KEY, JSON.stringify({ s: src, m: q.get("utm_medium") || "", c: q.get("utm_campaign") || "", t: Date.now() }));
  })();
  function utm() {
    try {
      var u = JSON.parse(read(UTM_KEY) || "null");
      if (u && Date.now() - u.t < 30 * 864e5) return u;
    } catch (e) {}
    return { s: "", m: "", c: "" };
  }

  function loadScript(src) { var s = document.createElement("script"); s.async = true; s.src = src; document.head.appendChild(s); }

  function metaLead(cats, eventId) {
    if (!CFG.pixel) return;
    if (!window.fbq) {
      var n = window.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!window._fbq) window._fbq = n;
      n.push = n; n.loaded = true; n.version = "2.0"; n.queue = [];
      loadScript("https://connect.facebook.net/en_US/fbevents.js");
    }
    try {
      window.fbq("init", CFG.pixel);
      window.fbq("trackSingle", CFG.pixel, "Lead", { content_name: "Lista Black Fiber", content_category: cats.join(", ") }, { eventID: eventId });
    } catch (e) {}
  }

  function googleLead(origem) {
    if (!CFG.ga4) return;
    if (!window.gtag) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      loadScript("https://www.googletagmanager.com/gtag/js?id=" + CFG.ga4);
    }
    try {
      window.gtag("config", CFG.ga4, { send_page_view: false });
      var done = 0, need = CFG.adsSendTo ? 2 : 1;
      return new Promise(function (ok) {
        function cb() { if (++done >= need) ok(); }
        setTimeout(ok, 2000);
        window.gtag("event", "generate_lead", { send_to: CFG.ga4, lead_source: "lista_black_" + origem, transport_type: "beacon", event_callback: cb });
        if (CFG.adsSendTo) window.gtag("event", "conversion", { send_to: CFG.adsSendTo, transport_type: "beacon", event_callback: cb });
      });
    } catch (e) {}
  }

  function submit(data) {
    var u = utm();
    var body = {
      nome: data.nome || "", email: (data.email || "").trim(), whatsapp: (data.whatsapp || "").replace(/\D/g, ""),
      categorias: data.categorias || [], aceite_email: !!data.aceite_email, aceite_whatsapp: !!data.aceite_whatsapp,
      origem: data.origem || "site", utm_source: u.s, utm_medium: u.m, utm_campaign: u.c, hp: data.hp || ""
    };
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 15000) : 0;
    return fetch(CFG.endpoint, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) {
      clearTimeout(timer);
      return r.json().catch(function () { return { ok: false, erro: "Resposta inválida do servidor." }; });
    }).then(function (res) {
      if (res && res.ok) {
        store(JOINED, "1");
        var eid = "fbl_" + Date.now() + "_" + Math.random().toString(36).slice(2, 8);
        metaLead(body.categorias, eid);
        var minWait = new Promise(function (ok) { setTimeout(ok, 1200); });
        return Promise.all([minWait, googleLead(body.origem)]).then(function () { return res; });
      }
      return res;
    }).catch(function () {
      clearTimeout(timer);
      return { ok: false, erro: "Não conseguimos enviar agora. Confira sua conexão e tente de novo." };
    });
  }

  window.FiberListaBlack = { submit: submit, joined: function () { return read(JOINED) === "1"; } };
})();
